// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"667fcceb","574":"2f57e8a8","820":"1eeb713f","881":"8e0e7d21"}[chunkId] + ".chunk.js";
};